<template>
  <div class="report-container">
    <div class="d-flex align-items-center justify-content-between header">
      <img class="report-top" src="@/assets/img/report-top.png" alt="" />
      <img class="report-bottom" src="@/assets/img/report-bottom.png" alt="" />
      <div class="d-flex flex-column report-header-text">
        <span class="report-title">报表中心</span>
        <span class="report-sub-title">
          支持自定义数据报表，多处业务数据统一管理，集中满足不同场景的数据需求
        </span>
        <!-- <span class="report-sub-title time">
          公测版
          <span class="line"></span>
          2023/08/25 - 2023/09/30
        </span> -->
      </div>
      <img
        class="report-icon"
        src="@/assets/img/report-icon.png"
        alt=""
        srcset=""
      />
    </div>
    <div class="operate-box">
      <a-button
        v-if="canCreate"
        class="new-aft-btn"
        type="primary"
        size="large"
        icon="plus"
        @click="openActivityReportEditionModal()"
      >
        创建报表
      </a-button>
    </div>
    <div>
      <a-table
        :pagination="false"
        :columns="columns"
        :dataSource="reportList"
        :loading="isLoading"
        rowKey="id"
        :scroll="{ y: 'calc(100vh - 441px)' }"
        :locale="{ emptyText: '暂无数据' }"
        class="aft-table default"
      >
        <template slot="action" slot-scope="row">
          <span
            class="btn"
            @click="openLink(row)"
            v-if="
              row.reportTemplateIsDeleted === 0 &&
              row.reportTemplateStatus === 1
            "
          >
            查看报表
          </span>
          <span class="btn" @click="openActivityReportDetailModal(row.id)">
            详情
          </span>
          <template v-if="currentUserName === row.creator">
            <span class="btn" @click="openActivityReportEditionModal(row.id)">
              编辑
            </span>
            <span class="btn" @click="deleteReport(row.id)">删除</span>
          </template>
        </template>
        <template slot="updateFrequency" slot-scope="text, item">
          <span
            >每{{ UPDATE_FREQUENCY_TYPE[item.updateFrequency] }}更新{{
              item.frequency
            }}次</span
          >
        </template>
      </a-table>
      <div
        class="d-flex justify-content-end new-aft-pagination"
        style="margin-top: 20px"
      >
        <a-pagination
          v-if="form.total > 0"
          v-model="form.page"
          size="large"
          :pageSize="form.size"
          :total="form.total"
          @change="pageChange"
        />
      </div>
    </div>

    <ActivityReportEditionModal
      ref="ActivityReportEditionModal"
      @success="getReportList"
    />
    <ActivityReportDetailModal ref="ActivityReportDetailModal" />
  </div>
</template>

<script>
import api from "@/api/activityReport.js";
import ActivityReportEditionModal from "./components/ActivityReportEditionModal";
import ActivityReportDetailModal from "./components/ActivityReportDetailModal";
import { getPrincipalId, getUserName } from "@/utils/auth";
import { isHmosPrincipal } from "@/constants/principal";

export default {
  components: { ActivityReportEditionModal, ActivityReportDetailModal },
  data() {
    return {
      UPDATE_FREQUENCY_TYPE: {
        1: "日",
        2: "周",
        3: "月",
        4: "季",
        5: "年",
      },
      isLoading: false,
      form: {
        page: 1,
        size: 50,
        total: 0,
      },
      columns: [
        {
          dataIndex: "reportName",
          title: "报表名称",
          align: "left",
        },
        {
          dataIndex: "reportTemplateType",
          title: "报表类型",
          align: "left",
        },
        {
          dataIndex: "nickName",
          title: "创建者",
          align: "left",
          width: 150,
        },
        {
          dataIndex: "updateFrequency",
          title: "更新频率",
          scopedSlots: { customRender: "updateFrequency" },
          align: "left",
        },
        {
          dataIndex: "ctime",
          title: "创建时间",
          align: "left",
          width: 180,
        },
        {
          title: "操作",
          align: "left",
          width: 230,
          scopedSlots: { customRender: "action" },
        },
      ],
      reportList: [],

      currentUserName: getUserName(),

      isHmos: isHmosPrincipal(getPrincipalId()),
      // 是否总部用户：null 未查询完成 / true 总部 / false 大区（仅鸿蒙智行查询）
      isHeadquarters: null,
      // 大区用户所属大区，scope=4 的报表查看时拼接到链接上；总部用户为空
      regionId: "",
    };
  },
  computed: {
    // 鸿蒙智行大区用户不可创建报表；查询完成前先不展示，避免按钮闪现
    canCreate() {
      if (!this.isHmos) return true;
      return this.isHeadquarters !== null && this.isHeadquarters !== false;
    },
  },
  methods: {
    async getReportList() {
      this.isLoading = true;
      try {
        const { data: res } = await api.getReportList(this.form);
        this.isLoading = false;
        if (res.code === 200) {
          this.reportList = res.data.list;
          this.form.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.isLoading = false;
      }
    },
    /**
     * 页数改变
     * @param {number} page 修改的页数
     */
    pageChange(page) {
      this.form.page = page;
      this.getReportList();
    },
    /**
     * 获取当前用户所属大区
     * 总部用户不查大区、不拼接；大区用户才查询 region_id
     * 进页面时预取，避免点击后异步请求导致 window.open 被浏览器拦截
     */
    async getRegionRole() {
      try {
        const { data: hqRes } = await api.isHeadquartersUser();
        // 接口文档示例 code 为 0，这里不校验 code，仅明确返回 false 时视为大区用户
        this.isHeadquarters = !(hqRes && hqRes.data === false);
        if (this.isHeadquarters) return;
        const { data: res } = await api.getRegionRoleList();
        this.regionId = (res && res.data && res.data.region_id) || "";
      } catch (error) {
        // 查询失败按总部处理：展示创建按钮、不拼接 region_id
        if (this.isHeadquarters === null) this.isHeadquarters = true;
      }
    },
    openLink(row) {
      const { reportTemplateLink, scope } = row;
      if (Number(scope) !== 4 || !this.regionId) {
        window.open(reportTemplateLink);
        return;
      }
      // 拼接在 hash 之前，兼容链接已带参数的情况
      const [url, hash] = reportTemplateLink.split("#");
      const separator = url.includes("?") ? "&" : "?";
      const link = `${url}${separator}region_id=${encodeURIComponent(
        this.regionId
      )}${hash !== undefined ? `#${hash}` : ""}`;
      window.open(link);
    },
    openActivityReportEditionModal(id) {
      this.$refs["ActivityReportEditionModal"].openModal(id);
    },
    openActivityReportDetailModal(id) {
      this.$refs["ActivityReportDetailModal"].openModal(id);
    },
    deleteReport(id) {
      this.$confirm({
        icon: () => <a-icon type="info-circle" theme="filled" />,
        title: "删除后将无法恢复，确认要删除这个报表吗？",
        onOk: () => {
          return api
            .deleteReport({ id })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success("删除成功");
                this.getReportList();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(() => {
              this.$message.error("删除失败");
            });
        },
        onCancel() {},
      });
    },
  },
  created() {
    this.getReportList();
    this.isHmos && this.getRegionRole();
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_handle.scss";
@import "@/assets/styles/flex.scss";

// 表格
.report-container {
  ::v-deep .aft-table.default.ant-table-wrapper .ant-table-header {
    margin-bottom: -4px !important;
  }
}
::v-deep .ant-table-thead > tr > th,
::v-deep .ant-table-tbody > tr > td {
  &:first-child {
    padding-left: 24px !important;
  }
}
::v-deep .ant-table-tbody > tr > td {
  padding-top: 14px !important;
  padding-bottom: 14px !important;
  cursor: default;
}
.aft-table.ant-table-wrapper {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.report-container {
  position: relative;
  padding: 20px;
  .header {
    width: 100%;
    height: 140px;
    background: linear-gradient(90deg, #303546 0%, #232733 100%);
    border-radius: 8px 8px 8px 8px;
    position: relative;
    overflow: hidden;

    .report-top {
      width: 437px;
      height: 105px;
      position: absolute;
      top: 0;
      left: 162px;
    }
    .report-bottom {
      width: 213px;
      height: 68px;
      position: absolute;
      bottom: 0;
      left: 378px;
    }

    .report-header-text {
      margin-left: 30px;
      z-index: 1;
      .report-title {
        font-size: 24px;
        @include font_color("font_color58");
      }
      .report-sub-title {
        @include font_color("font_color59");
        margin-top: 8px;
        display: flex;
        align-items: center;
        &.time {
          margin-top: 16px;
        }
        .line {
          margin: 0 8px;
          display: inline-block;
          width: 1px;
          height: 14px;
          background: rgba($color: #ffffff, $alpha: 0.55);
        }
      }
    }

    .report-icon {
      width: 102px;
      height: 104px;
      margin-right: 100px;
      z-index: 1;
    }
  }

  .operate-box {
    margin-top: 20px;
    margin-bottom: 16px;
    text-align: right;
  }

  .btn {
    margin-right: 16px;
    color: #ffcc55;
    cursor: pointer;
  }
}
</style>
